<template>
  <div class="page">
    <header-banner :list="banners" />
    <header-notice :list="notices" />
    <header-title :title="detail.title" :cover="detail.mainImg" />
    <header-nav />
    <info :detail="detail" />
    <iain-gap height="10" bg-color="#EEEEEE" />
    <sponsor :detail="detail" />
    <iain-gap height="10" bg-color="#EEEEEE" />
    <more :rich="rich" :lives="lives" :album="album" />
    <div class="placeholder">更多精彩内容，请下载聚亲APP查看</div>
    <download :scheme="`juqin://?type=activity_detail&id=` + activityId" />
  </div>
</template>

<script>
import HeaderBanner from './components/HeaderBanner'
import HeaderNotice from './components/HeaderNotice'
import HeaderTitle from './components/HeaderTitle'
import HeaderNav from './components/HeaderNav'
import Info from './components/Info'
import Sponsor from './components/Sponsor'
import More from './components/More'

export default {
  name: 'ActivityDetail',
  components: {
    HeaderBanner,
    HeaderNotice,
    HeaderTitle,
    HeaderNav,
    Info,
    Sponsor,
    More
  },
  data() {
    return {
      activityId: '',
      detail: {},
      rich: '',
      lives: [],
      album: []
    }
  },
  computed: {
    banners() {
      return this.detail.sponsor ? this.detail.sponsor.company || [] : []
    },
    notices() {
      return this.detail.donateNoticeList || []
    }
  },
  mounted() {
    this.activityId = this.$route.query.id
    this.init()
  },
  methods: {
    async init() {
      const loading = this.$toast.loading({ message: '加载中' })
      await Promise.all([this.getDetail(), this.getLive(), this.getAlbum()])
      loading.clear()
    },

    async getDetail() {
      const response = await this.$request.api.get({ url: this.$api.activityDetailUrl + this.activityId })
      const { success, message, code, data } = response

      if (success && code === 200) {
        this.detail = data || {}
        this.rich = this.detail.info
      } else {
        this.$toast.fail(message || '获取详情失败')
      }
    },

    async getLive() {
      const response = await this.$request.api.get({ url: this.$api.activityLiveUrl + this.activityId, data: { current: 1, size: 10 } })
      const { success, message, data, code } = response

      if (success && code === 200) {
        this.lives = data.records
      } else {
        this.$toast.fail(message || '获取直播动态失败')
      }
    },

    async getAlbum() {
      const response = await this.$request.api.get({ url: this.$api.activityAlbumUrl + this.activityId, data: { current: 1, size: 10 } })
      const { success, message, data, code } = response

      if (success && code === 200) {
        this.album = data.records
      } else {
        this.$toast.fail(message || '获取活动相册失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.placeholder {
  padding: 10px 0;
  text-align: center;
  color: #BBBBBB;
}
</style>
